// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { defichainEvm as _defichainEvm } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the defichainEvm chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1130
 * Chain Name: DeFiChain EVM Mainnet
 * Default Block Explorer: https://meta.defiscan.live
 * Default RPC URL: https://eth.mainnet.ocean.jellyfishsdk.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { defichainEvm } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: defichainEvm,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const defichainEvm = createCommon({
	..._defichainEvm,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
